import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "../../lib/api";
import { ProgressPanel } from "./ProgressPanel";

export const ProgressTab = ({ clients }) => {
  const [cid, setCid] = useState("");
  const [items, setItems] = useState(null);
  const load = useCallback(() => (cid ? api.get(`/admin/test-progress/${cid}`).then((r) => setItems(r.data)).catch((e) => toast.error(formatErr(e))) : setItems(null)), [cid]);
  useEffect(() => { load(); }, [load]);
  return (
    <div data-testid="tp-tab">
      <select className="qv-input" value={cid} onChange={(e) => setCid(e.target.value)} style={{ maxWidth: 360, marginBottom: 14 }} data-testid="tp-client">
        <option value="">— Elige un futbolista —</option>{clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
      </select>
      {items && <ProgressPanel items={items} admin reload={load} />}
    </div>
  );
};
